import ActivationEmails from '@/views/ActivationEmails/ActivationEmails.vue';
import flagKeys from '@/constants/flagKeys';

import { Route } from '../route.model';
import { IBusinessType } from '@/models/business';
import { customerImportValidator } from '../validators/navbar';

const activationEmails = new Route(
  '/activation-emails',
  'settings-activation-emails',
  ActivationEmails,
  {
    isResponsive: flagKeys.responsiveDashboard,
    flag: flagKeys.customerAcquisition,
    validator: () => customerImportValidator(),
    requiresAuth: true,
    onlyManager: true,
    zendesk: {
      mobile: {
        offsetHorizontal: '4px',
        offsetVertical: '4px'
      }
    },
    navbar: {
      name: 'Email Automation',
      icon: 'email-automation',
      description:
        'Activate pre-designed email campaigns to current & potential members.'
    },
    pageView: {
      eventLabel: 'Email Automation'
    },
    feature: {
      type: IBusinessType.ONLINE
    },
    needProviderConnected: true
  }
);

export { activationEmails };
export default activationEmails;
